import { Button } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledButton = styled(Button)(({
                                              variant,
                                              size,
                                              color
                                            }) => ({
    padding: "0 16px",
    height: "44px",
    fontWeight: 700,
    fontSize: "14px",
    textTransform: "inherit",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    },
    "&.role-button:hover": {
      backgroundColor: "#005f3e"
    },
    "&.Mui-disabled": {
      "&[class*='MuiButton-text']": {
        color: "rgba(142, 129, 140) !important"
      }
    },
    "& .MuiSvgIcon-root": {
      color: "inherit"
    },
    ...variant === "outlined" && outlined,
    ...variant === "contained" && contained,
    ...color === "error" && error,
    ...color === "info" && variant === "text" && info,
    ...size === "medium" && medium,
    ...color === "secondary" && secondary
  })
)

const disabled = {
  border: "2px solid #9B9B9B",
  background: "#E1E1E1",
  "&[class*='MuiButton-text']": {
    color: "rgba(0, 0, 0, .38) !important"
  },
  "& .MuiSvgIcon-root": {
    color: "rgba(0, 0, 0, .26) !important"
  }
}

const outlined = {
  "&[class*=MuiButton-root]": {
    "&.Mui-disabled": disabled,
    border: "2px solid",
    padding: "0 14px"
  },
  "&.MuiButton-outlinedSecondary": {
    color: "#1A1A1A",
    borderColor: "#79747E"
  }
}

const secondary = {
  color: "#554854",
  "&.Mui-disabled": {
    borderColor: "#9B9B9B",
  }
}

const contained = {
  color: "#fff",
  boxShadow: "none",
  "&.Mui-disabled": disabled,
  "&:hover": {
    boxShadow: "none"
  }
}

const medium = {
  height: "38px",
  padding: "14px"
}

const error = {
  "&.MuiButton-containedError": {
    backgroundColor: "#DF4C47",

    "&:hover": {
      backgroundColor: "#902f2f"
    }
  }
}

const info = {
  color: "#00287A"
}
